import * as React from "react";
import { Grid } from "@mui/material";
import ConnectionCard from "../../../components/installation/connection_card";
import PeakShavingCard from "components/installation/peak_shaving_card";
// import AccesPowerCard from "components/schematic/acces_power_card";

export default function InstallationTab({ required_privilege }) {
  return (
    <Grid container spacing={2}>
      {/* <Grid item xs={12}>
        <AccesPowerCard required_privilege={required_privilege} />
      </Grid> */}
      <Grid item xs={12}>
        <ConnectionCard required_privilege={required_privilege} />
      </Grid>
      <Grid item xs={12}>
        <PeakShavingCard required_privilege={required_privilege} />
      </Grid>
    </Grid>
  );
}
